import { Component, OnInit, inject } from '@angular/core';

import { TrackingService, WebAnalyticsEventType } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';

import { AccountMenuItemBase } from '../../account-menu-item-base';
import { AccountMenuWidgetComponent } from './widget.component';

/**
 * Sitecore: {@link http://cms.prod.env.works/sitecore/DirectLink.aspx?fo={5E509F35-AB2B-4528-B84E-B50B435960D5}&la=}
 */
@Component({
    imports: [AccountMenuWidgetComponent, TrustAsHtmlPipe],
    selector: 'vn-am-text-widget',
    templateUrl: 'text-widget.html',
})
export class TextWidgetComponent extends AccountMenuItemBase implements OnInit {
    private trackingService = inject(TrackingService);

    hideSkeleton: boolean = false;

    ngOnInit() {
        this.hideSkeleton = true;
        this.trackingService.trackEvents(this.item, WebAnalyticsEventType.load);
    }
}
